module.exports = __webpack_public_path__ + "img/01.old.25bc97c6.webp";